var React = require('react');

function HierarchyLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 10a1 1 0 011 1v26a1 1 0 11-2 0V11a1 1 0 011-1z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 26.002a11 11 0 00-11 11 1 1 0 11-2 0 13 13 0 0113-13h12a13 13 0 0113 13 1 1 0 11-2 0 11 11 0 00-11-11H18zM18 1a1 1 0 011-1h10a1 1 0 011 1v10a1 1 0 01-1 1H19a1 1 0 01-1-1V1zm2 1v8h8V2h-8z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 37a1 1 0 011-1h10a1 1 0 011 1v10a1 1 0 01-1 1H19a1 1 0 01-1-1V37zm2 1v8h8v-8h-8zM0 37a1 1 0 011-1h10a1 1 0 011 1v10a1 1 0 01-1 1H1a1 1 0 01-1-1V37zm2 1v8h8v-8H2zm34-1a1 1 0 011-1h10a1 1 0 011 1v10a1 1 0 01-1 1H37a1 1 0 01-1-1V37zm2 1v8h8v-8h-8z","key":2})]);
}

HierarchyLight.defaultProps = {"viewBox":"0 0 48 49"};

module.exports = HierarchyLight;

HierarchyLight.default = HierarchyLight;
